/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Gyms_Delete_TitleInputs */

const en_us2_gyms_delete_title = /** @type {(inputs: Gyms_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}?`)
};

const pt_br2_gyms_delete_title = /** @type {(inputs: Gyms_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Excluir ${i?.name}?`)
};

const es_419_gyms_delete_title = /** @type {(inputs: Gyms_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Eliminar ${i?.name}?`)
};

const pt_pt2_gyms_delete_title = /** @type {(inputs: Gyms_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminar ${i?.name}?`)
};

const fr_fr2_gyms_delete_title = /** @type {(inputs: Gyms_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer ${i?.name} ?`)
};

const de_de2_gyms_delete_title = /** @type {(inputs: Gyms_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} löschen?`)
};

const it_it2_gyms_delete_title = /** @type {(inputs: Gyms_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminare ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "Delete {name}?" |
*
* @param {Gyms_Delete_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_delete_title = /** @type {((inputs: Gyms_Delete_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Delete_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_delete_title(inputs)
	if (locale === "es-419") return es_419_gyms_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_delete_title(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_delete_title(inputs)
	if (locale === "de-DE") return de_de2_gyms_delete_title(inputs)
	if (locale === "it-IT") return it_it2_gyms_delete_title(inputs)
	return en_us2_gyms_delete_title(inputs)
});
export { gyms_delete_title as "gyms.delete_title" }